import React, {
  FocusEvent,
  RefObject,
  KeyboardEvent,
} from 'react';
import clsx from 'clsx';
import MaskedTextField from 'core/components/MaskedTextField';
import {
  isEmptyString,
} from '@populateui/utils';
import isNil from 'lodash/isNil';

const amountBlock = Object.freeze({
  mask: Number,
  thousandsSeparator: ',',
  scale: 2,
  normalizeZeros: true,
  padFractionalZeros: false,
  radix: '.',
  placeholderChar: '0',
});

const mask = [{
  mask: '$amount',
  lazy: false,
  overwrite: true,
  blocks: { amount: amountBlock },
}];

type Props = {
  id?: string;
  value?: string | number | null;
  onChange: (value: string | number | null | undefined) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  inputProps?: object;
  inputRef?: RefObject<HTMLInputElement>;
  defaultValue?: string | number | null;
  nullIfEmpty?: boolean;
  allowNegative?: boolean;
  disabled?: boolean;
  error?: boolean;
  showErrorText?: boolean;
};

export default function CurrencyTextField({
  value,
  className,
  onChange,
  onKeyDown,
  defaultValue = '0',
  nullIfEmpty = false,
  allowNegative = false,
  disabled = false,
  showErrorText,
  error = false,
  ...props
}: Props) {
  const fieldMask = allowNegative
    ? mask
    : [{
      ...mask[0],
      blocks: {
        amount: {
          ...amountBlock,
          min: 0,
        },
      },
    }];

  return (
    <MaskedTextField
      {...props}
      unmask
      mask={fieldMask}
      value={isNil(value) ? undefined : String(value)}
      defaultValue={defaultValue ?? undefined}
      onAccept={(value: string) => {
        onChange(nullIfEmpty && isEmptyString(value) ? undefined : value);
      }}
      maskedPosition={{ start: 1, end: 0 }}
      disabled={disabled}
      error={error}
      showErrorText={showErrorText}
      onKeyDown={onKeyDown}
      className={clsx('populate-input populate-currency-input bg-white', className, {
        'has-error': error,
      })}
    />
  );
}
